import { Grid } from "@mui/material";
import { ERR_NETWORK } from "constants/messages";
import { getCurrentWeekNum, getCurrentYearNum } from "lib/date";
import { getWeeklySlots } from "models/weeklySlotsModel";
import { useSnackbar } from "notistack";
import BoxesSummary from "pages/boxes/BoxesSummary";
import { useEffect, useState } from "react";
import { openLoading } from "store/reducers/tools";
import { SelectDayDetail } from "./SelectDayDetail";
import PopularFlavours from "./forms/PopularFlavours";
import SalesBarChart from "./forms/SalesBarChart";

export default function Dashboard() {
  const { enqueueSnackbar } = useSnackbar();
  const [weeklySlots, setWeeklySlots] = useState([]);
  const loadWeeklyData = () => {
    openLoading(true);
    getWeeklySlots({
      data: {
        week_num: getCurrentWeekNum(),
        week_year: getCurrentYearNum(),
      },
      onFinish: (res, err) => {
        openLoading(false);
        if (res === false) {
          if (!res && err?.message) {
            enqueueSnackbar(err?.message, { variant: "warning" });
          } else {
            enqueueSnackbar(ERR_NETWORK.LONG, { variant: "warning" });
          }
          return;
        }
        setWeeklySlots(res);
      },
    });
  };

  useEffect(() => {
    loadWeeklyData();
    //eslint-disable-next-line
  }, []);

  return (
    <div>
      <Grid container spacing={4}>
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <BoxesSummary data={weeklySlots} />
        </Grid>
        <Grid item lg={9} md={12} sm={12} xs={12}>
          <Grid container spacing={4}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              {/* <SalesChart /> */}
              <SelectDayDetail />
            </Grid>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <SalesBarChart />
            </Grid>
          </Grid>
        </Grid>
        <Grid item lg={3} md={12} sm={12} xs={12}>
          <PopularFlavours />
        </Grid>
      </Grid>
    </div>
  );
}
